import { render, staticRenderFns } from "./contentPricingEdit.vue?vue&type=template&id=f6814b82&"
import script from "./contentPricingEdit.vue?vue&type=script&lang=js&"
export * from "./contentPricingEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports